import { eType, Section } from "../Section";
import { GameWorld, eGameObject as eWorldObject } from "../../GameWorld";

export class SafeArea_1 extends Section {
    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super("safeArea_1", eType.safeArea_1, false);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected addObjectEntities(): void {
        let world = GameWorld.instance;

        // Zem
        let e = world.getObjectNewEntity(eWorldObject.safeArea_0);
        e.setLocalPosition(0, 0, 0);
        e.reparent(this._root);

        // Kvetinace
        e = world.getObjectNewEntity(eWorldObject.flowerPot);
        e.setLocalPosition(-0.7, 0, -0.05);
        e.reparent(this._root);

        e = world.getObjectNewEntity(eWorldObject.flowerPot);
        e.setLocalPosition(0.7, 0, -0.05);
        e.reparent(this._root);

        // Stromy
        e = world.getObjectNewEntity(eWorldObject.tree);
        e.setLocalPosition(-1.5, 0.04, 0);
        e.setLocalScale(1, 1, 0.7);
        e.reparent(this._root);

        e = world.getObjectNewEntity(eWorldObject.tree);
        e.setLocalPosition(1.3, 0.04, 0);
        e.setLocalScale(1, 1, 0.7);
        e.reparent(this._root);
    }
}